import { c as _c } from "react/compiler-runtime";
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize, formatPrice } from '@winelidays/wld-tsx-2/utils';
import Segmentation from './Segmentation';
const getPriceContent = ({ priceRange, translate, currencySymbol }) => {
    const { lower, upper } = priceRange;
    if (upper === null || lower === upper) {
        return translate('practical.price_range.unique', {
            price: formatPrice(lower || 0),
            currencySymbol
        });
    }
    return translate('practical.price_range.dual', {
        min: formatPrice(lower || 0),
        max: formatPrice(upper || 0),
        currencySymbol
    });
};
const ExperiencePriceContent = (t0) => {
    const $ = _c(16);
    const { priceRange, hasSegmentation, segmentation, tariffName } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    let t1;
    let t2;
    if ($[0] !== currencySymbol || $[1] !== hasSegmentation || $[2] !== priceRange || $[3] !== translate) {
        const priceContent = getPriceContent({ priceRange, translate, currencySymbol });
        const priceClassName = `align-baseline ${hasSegmentation ? "mr-3" : ""}`;
        t1 = priceClassName;
        t2 = capitalize(priceContent);
        $[0] = currencySymbol;
        $[1] = hasSegmentation;
        $[2] = priceRange;
        $[3] = translate;
        $[4] = t1;
        $[5] = t2;
    }
    else {
        t1 = $[4];
        t2 = $[5];
    }
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = <span className={t1}>{t2}</span>;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    }
    else {
        t3 = $[8];
    }
    let t4;
    if ($[9] !== hasSegmentation || $[10] !== segmentation || $[11] !== tariffName) {
        t4 = hasSegmentation && segmentation &&
            <Segmentation segmentation={segmentation} tariffName={tariffName}/>;
        $[9] = hasSegmentation;
        $[10] = segmentation;
        $[11] = tariffName;
        $[12] = t4;
    }
    else {
        t4 = $[12];
    }
    let t5;
    if ($[13] !== t3 || $[14] !== t4) {
        t5 = <><>{t3}{t4}</></>;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    }
    else {
        t5 = $[15];
    }
    return t5;
};
export default ExperiencePriceContent;
